module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/sortie-8.524db365.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/sortie-8.png
// module id = 2760
// module chunks = 11